export default __webpack_public_path__ + "static/media/c002-PPII-9.8453df2c.svg";